(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  function formatMoney(cents) {
    return window.Shopify && typeof Shopify.formatMoney === 'function'
      ? Shopify.formatMoney(cents)
      : '\u20B9' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function normalizeImageUrl(url, width) {
    if (!url) return '';
    if (url.startsWith('//')) url = 'https:' + url;
    if (!url.startsWith('http')) url = 'https:' + url;
    try {
      url = url.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+)(\?|$)/i, '$2$3');
      var u = new URL(url);
      u.searchParams.delete('width');
      u.searchParams.delete('height');
      if (width) u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  var CART_SVG = '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2;flex-shrink:0;pointer-events:none"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2.5;flex-shrink:0;pointer-events:none"><polyline points="20 6 9 17 4 12"/></svg>';
  function spinSVG() {
    return '<svg viewBox="0 0 24 24" style="width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2;flex-shrink:0;pointer-events:none;animation:bsOvSpin 0.75s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="10"/></svg>';
  }

  /* ── Per-section init ─────────────────────────────────── */
  function initSection(sectionEl) {
    var SID = sectionEl.dataset.sid;
    if (!SID || sectionEl._bsInit) return;
    sectionEl._bsInit = true;

    var track = document.getElementById('bsTrack-' + SID);
    if (!track) return;

    var origCards = Array.prototype.slice.call(track.querySelectorAll('.bs-card'));
    if (!origCards.length) return;

    /* ── Clone cards for infinite scroll ─────────────────── */
    /* Make enough copies so the loop always has room to scroll,
       even when there are fewer cards than cards-per-row. */
    var perRow = Math.max(
      parseInt(sectionEl.dataset.cpd, 10) || 4,
      parseInt(sectionEl.dataset.cpm, 10) || 2
    );
    var cloneSets = Math.max(1, Math.ceil((perRow + 1) / origCards.length));
    for (var cs = 0; cs < cloneSets; cs++) {
      origCards.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('bs-card-clone');
        // var lnk = clone.querySelector('.bs-card-link');
        // if (lnk) lnk.removeAttribute('href');
        track.appendChild(clone);
      });
    }

    /* ── Badge typing effect ──────────────────────────────── */
    var BS = parseInt(sectionEl.dataset.badgeTypingSpeed, 10) || 70;
    var BD = Math.max(30, Math.floor(BS / 2));

    function badgeType(el, delay) {
      var txt = el.dataset.badgeText || '';
      if (!txt) return;
      el.textContent = '';
      setTimeout(function () {
        var i = 0, del = false;
        (function tick() {
          if (!del) {
            el.textContent = txt.slice(0, ++i);
            if (i >= txt.length) { del = true; setTimeout(tick, 1800); }
            else setTimeout(tick, BS);
          } else {
            el.textContent = txt.slice(0, --i);
            if (i <= 0) { del = false; setTimeout(tick, 400); }
            else setTimeout(tick, BD);
          }
        })();
      }, delay);
    }

    Array.prototype.slice.call(track.querySelectorAll('.bs-card')).forEach(function (card, idx) {
      card.querySelectorAll('.bs-badge-typing').forEach(function (el) {
        badgeType(el, 400 + idx * 250);
      });
    });

    /* ── Carousel helpers ─────────────────────────────────── */
    function getStep() {
      var c = track.querySelector('.bs-card');
      return c ? c.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0) : 300;
    }

    function getOrigW() {
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return Array.prototype.slice.call(track.querySelectorAll('.bs-card:not(.bs-card-clone)'))
        .reduce(function (s, c) { return s + c.offsetWidth + gap; }, 0);
    }

    var scrollWrapT = null;
    function onTrackScroll() {
      clearTimeout(scrollWrapT);
      scrollWrapT = setTimeout(function () {
        var ow = getOrigW();
        if (!ow) return;
        var j = false;
        if (track.scrollLeft >= ow) { track.style.scrollSnapType = 'none'; track.scrollLeft -= ow; j = true; }
        else if (track.scrollLeft < 0) { track.style.scrollSnapType = 'none'; track.scrollLeft += ow; j = true; }
        if (j) requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
      }, 120);
    }

    function bindTrackListeners(t) {
      if (t._bsBound) return;
      t._bsBound = true;
      t.addEventListener('scroll', onTrackScroll, { passive: true });
    }

    bindTrackListeners(track);

    var sc = false;
    function smoothTo(from, to, dur) {
      if (sc) return;
      sc = true;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = from;
      var d = to - from, t0 = null;
      function ease(p) { return p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; }
      (function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        track.scrollLeft = from + d * ease(p);
        if (p < 1) { requestAnimationFrame(step); return; }
        track.scrollLeft = to;
        sc = false;
        var ow = getOrigW();
        if (ow) {
          if (track.scrollLeft >= ow) track.scrollLeft -= ow;
          else if (track.scrollLeft < 0) track.scrollLeft += ow;
        }
        requestAnimationFrame(function () { track.style.scrollSnapType = ''; });
      })(0);
    }

    var prevBtn = document.getElementById('bsPrev-' + SID);
    var nextBtn = document.getElementById('bsNext-' + SID);

    if (prevBtn) prevBtn.addEventListener('click', function () {
      var step = getStep(), from = track.scrollLeft, to = from - step;
      if (to < 0) { var ow = getOrigW(); smoothTo(ow, ow - step, 280); }
      else smoothTo(from, to, 280);
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      smoothTo(track.scrollLeft, track.scrollLeft + getStep(), 280);
    });

    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        var freshTrack = document.getElementById('bsTrack-' + SID);
        if (freshTrack && !freshTrack._bsBound) bindTrackListeners(freshTrack);
      });
      mo.observe(sectionEl, { childList: true, subtree: true });
    }

    /* ── Cart helpers ─────────────────────────────────────── */
    var productCache = {};

    function getCartSectionIds() {
      var ids = [];
      ['cart-drawer', 'cart-notification', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].forEach(function (id) {
        if (document.getElementById(id)) ids.push(id);
      });
      document.querySelectorAll('[data-section-id]').forEach(function (el) {
        var sid = el.getAttribute('data-section-id');
        if (sid && /cart|header/i.test(sid) && ids.indexOf(sid) === -1) ids.push(sid);
      });
      document.querySelectorAll('[id]').forEach(function (el) {
        if (/cart|header/i.test(el.id) && ids.indexOf(el.id) === -1) ids.push(el.id);
      });
      return ids.slice(0, 6);
    }

    function applySectionRenders(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (sectionId) {
        var html = sections[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var target = document.getElementById(sectionId);
        if (target) {
          var fresh = doc.querySelector('#' + sectionId);
          target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        }
      });
    }

    function openCartDrawer() {
      ['cart:open', 'theme:cart:open', 'cart:refresh', 'cart-notification:open'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      window.dispatchEvent(new CustomEvent('cart:open'));
      var triggers = [
        '[data-cart-drawer-trigger]', '[data-cart-toggle]', '[data-cart-open]',
        '.js-cart-link', '.cart-drawer__toggle', '.header__icon--cart',
        '.header-cart', '.cart-icon-wrapper a', 'a[href="/cart"]',
        '[aria-label="Cart"]', '[aria-label="Open cart"]', '[aria-label*="cart" i]'
      ];
      for (var i = 0; i < triggers.length; i++) {
        var candidates = document.querySelectorAll(triggers[i]);
        for (var j = 0; j < candidates.length; j++) {
          var el = candidates[j];
          if (el.closest('[class*="bsell-"]')) continue;
          el.click();
          return;
        }
      }
    }

    function fetchAddToCart(variantId, qty, onSuccess, onError) {
      var sectionIds = getCartSectionIds();
      var body = { id: Number(variantId), quantity: Number(qty) };
      if (sectionIds.length) body.sections = sectionIds;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
          if (res.data && res.data.sections) applySectionRenders(res.data.sections);
          ['cart:refresh', 'cart:updated', 'theme:cart:open', 'on:cart:add'].forEach(function (e) {
            document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
          });
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          if (onSuccess) onSuccess(res.data);
        })
        .catch(function (err) { if (onError) onError(err); });
    }

    function refreshCartSections(onDone) {
      var sectionIds = getCartSectionIds();
      if (!sectionIds.length) { if (onDone) onDone(); return; }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: {}, sections: sectionIds })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.sections) applySectionRenders(data.sections);
          ['cart:refresh', 'cart:updated'].forEach(function (e) {
            document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
          });
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          if (onDone) onDone();
        })
        .catch(function () { if (onDone) onDone(); });
    }

    function addToCartAndOpenDrawer(variantId, qty, atcBtn, ov) {
      var nativeForm = document.querySelector('.js-product-form') || document.querySelector('form[action*="/cart/add"]');
      var nativeBtn = nativeForm ? nativeForm.querySelector('button[name="add"]') : null;
      if (nativeForm && nativeBtn) {
        var vi = nativeForm.querySelector('input[name="id"]');
        if (vi) { vi.disabled = false; vi.value = String(variantId); }
        var qi = nativeForm.querySelector('input[name="quantity"]');
        if (qi) qi.value = String(qty);
        nativeBtn.click();
        atcBtn.innerHTML = CHECK_SVG + ' Added!';
        setTimeout(function () {
          refreshCartSections(function () { openCartDrawer(); });
        }, 500);
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.innerHTML = CART_SVG + ' Add To Cart';
          if (ov) { ov.classList.remove('is-open'); var c = ov.closest('.bs-card'); if (c) c.classList.remove('bs-ov-active'); }
        }, 1800);
      } else {
        atcBtn.disabled = true;
        atcBtn.innerHTML = spinSVG() + ' Adding…';
        fetchAddToCart(variantId, qty,
          function () {
            atcBtn.innerHTML = CHECK_SVG + ' Added!';
            openCartDrawer();
            setTimeout(function () {
              atcBtn.disabled = false;
              atcBtn.innerHTML = CART_SVG + ' Add To Cart';
              if (ov) { ov.classList.remove('is-open'); var c = ov.closest('.bs-card'); if (c) c.classList.remove('bs-ov-active'); }
            }, 1800);
          },
          function (err) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = CART_SVG + ' Add To Cart';
            alert(err && err.message ? err.message : 'Could not add to cart.');
          }
        );
      }
    }

    /* ── Overlay ──────────────────────────────────────────── */
    function closeAllOverlays(except) {
      track.querySelectorAll('.bs-card-overlay.is-open').forEach(function (ov) {
        if (ov !== except) {
          ov.classList.remove('is-open');
          var c = ov.closest('.bs-card');
          if (c) c.classList.remove('bs-ov-active');
        }
      });
    }

    function buildOverlayHTML(product, card) {
      var variants = product.variants || [], options = product.options || [];
      var sel = variants.find(function (v) { return v.available; }) || variants[0];
      card._ovVariant = sel;
      card._ovQty = 1;
      var hasOptions = options.length > 0 && !(options.length === 1 && (typeof options[0] === 'object' ? options[0].name : options[0]) === 'Title');
      var sizesHTML = '';
      if (hasOptions) {
        var optName = typeof options[0] === 'object' ? options[0].name : options[0];
        var vals = Array.from(new Set(variants.map(function (v) { return v.option1; })));
        sizesHTML = '<p class="bs-ov-label">' + optName + '</p><div class="bs-ov-sizes">';
        vals.forEach(function (val) {
          var avail = variants.some(function (v) { return v.option1 === val && v.available; });
          var isOn = sel && sel.option1 === val ? ' is-on' : '';
          sizesHTML += '<button class="bs-ov-size-btn' + isOn + (avail ? '' : ' is-na') + '" data-val="' + String(val).replace(/"/g, '&quot;') + '" type="button">' + val + '</button>';
        });
        sizesHTML += '</div>';
      }
      var maxQty = sel && sel.inventory_quantity > 0 ? sel.inventory_quantity : 999;
      var avail = sel ? sel.available : false;
      return '<div class="bs-ov-glass">'
        + '<button class="bs-ov-close" data-ov-close type="button" aria-label="Close">&times;</button>'
        + sizesHTML
        + '<div class="bs-ov-qty-row"><span class="bs-ov-qty-label">Quantity</span>'
        + '<div class="bs-ov-qty-selector">'
        + '<button class="bs-ov-qty-btn" data-ov-minus type="button">&#8722;</button>'
        + '<input class="bs-ov-qty-val" data-ov-qty type="number" value="1" min="1" max="' + maxQty + '" readonly>'
        + '<button class="bs-ov-qty-btn" data-ov-plus type="button">&#43;</button>'
        + '</div></div></div>'
        + '<button class="bs-ov-atc-btn" data-ov-atc type="button"' + (avail ? '' : ' disabled') + '>'
        + CART_SVG + (avail ? 'Add To Cart' : 'Sold Out') + '</button>';
    }

    function refreshATCState(card) {
      var overlay = card.querySelector('[data-overlay]');
      if (!overlay) return;
      var btn = overlay.querySelector('[data-ov-atc]'), inp = overlay.querySelector('[data-ov-qty]'), v = card._ovVariant;
      if (!btn) return;
      var avail = v ? v.available : false;
      btn.disabled = !avail;
      btn.innerHTML = CART_SVG + (avail ? 'Add To Cart' : 'Sold Out');
      if (inp && v) {
        var m = v.inventory_quantity > 0 ? v.inventory_quantity : 999;
        inp.max = String(m);
        if (parseInt(inp.value) > m) { inp.value = String(m); card._ovQty = m; }
      }
    }

    function openCardOverlay(card) {
      var overlay = card.querySelector('[data-overlay]');
      if (!overlay) return;
      closeAllOverlays(overlay);
      var handle = card.dataset.handle;
      if (!handle) return;
      var inner = overlay.querySelector('[data-ov-inner]');
      if (!inner) return;
      overlay.classList.add('is-open');
      card.classList.add('bs-ov-active');
      if (productCache[handle]) { inner.innerHTML = buildOverlayHTML(productCache[handle], card); return; }
      inner.innerHTML = '<div style="font-size:12px;color:#888;text-align:center;padding:14px 0;">Loading…</div>';
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          productCache[handle] = p;
          if (overlay.classList.contains('is-open')) inner.innerHTML = buildOverlayHTML(p, card);
        })
        .catch(function () {
          if (overlay.classList.contains('is-open')) inner.innerHTML = '<div style="font-size:11px;color:#c00;text-align:center;padding:10px 0;">Could not load.</div>';
        });
    }

    /* ── Section click delegation ─────────────────────────── */
    sectionEl.addEventListener('click', function (e) {
      var t = e.target;

      var atcTrigger = t.closest('.bs-atc-btn');
      if (atcTrigger) {
        e.preventDefault(); e.stopPropagation();
        var card = atcTrigger.closest('.bs-card');
        if (!card) return;
        var ov = card.querySelector('[data-overlay]');
        if (ov && ov.classList.contains('is-open')) { ov.classList.remove('is-open'); card.classList.remove('bs-ov-active'); }
        else openCardOverlay(card);
        return;
      }

      var closeBtn = t.closest('[data-ov-close]');
      if (closeBtn) {
        e.preventDefault(); e.stopPropagation();
        var ov = closeBtn.closest('[data-overlay]');
        if (ov) { ov.classList.remove('is-open'); var c = ov.closest('.bs-card'); if (c) c.classList.remove('bs-ov-active'); }
        return;
      }

      var sizeBtn = t.closest('.bs-ov-size-btn');
      if (sizeBtn && !sizeBtn.classList.contains('is-na')) {
        e.preventDefault(); e.stopPropagation();
        var card = sizeBtn.closest('.bs-card');
        if (!card) return;
        var p = productCache[card.dataset.handle];
        if (!p) return;
        sizeBtn.closest('.bs-ov-sizes').querySelectorAll('.bs-ov-size-btn').forEach(function (b) { b.classList.remove('is-on'); });
        sizeBtn.classList.add('is-on');
        var m = p.variants.find(function (v) { return v.option1 === sizeBtn.dataset.val; });
        if (m) { card._ovVariant = m; refreshATCState(card); }
        return;
      }

      var minusBtn = t.closest('[data-ov-minus]');
      if (minusBtn) {
        e.preventDefault(); e.stopPropagation();
        var card = minusBtn.closest('.bs-card');
        if (!card) return;
        var inp = card.querySelector('[data-ov-qty]');
        var val = Math.max(1, (card._ovQty || 1) - 1);
        card._ovQty = val;
        if (inp) inp.value = String(val);
        return;
      }

      var plusBtn = t.closest('[data-ov-plus]');
      if (plusBtn) {
        e.preventDefault(); e.stopPropagation();
        var card = plusBtn.closest('.bs-card');
        if (!card) return;
        var v = card._ovVariant;
        var max = v && v.inventory_quantity > 0 ? v.inventory_quantity : 999;
        var inp = card.querySelector('[data-ov-qty]');
        var val = Math.min(max, (card._ovQty || 1) + 1);
        card._ovQty = val;
        if (inp) inp.value = String(val);
        return;
      }

      var atcBtn = t.closest('[data-ov-atc]');
      if (atcBtn) {
        e.preventDefault(); e.stopPropagation();
        var card = atcBtn.closest('.bs-card');
        if (!card) return;
        var v = card._ovVariant;
        if (!v || !v.available || atcBtn.disabled) return;
        var qty = card._ovQty || 1;
        var ov = card.querySelector('[data-overlay]');
        atcBtn.disabled = true;
        atcBtn.innerHTML = spinSVG() + ' Adding…';
        addToCartAndOpenDrawer(v.id, qty, atcBtn, ov);
        return;
      }

      if (t.closest('.bs-card-overlay')) e.stopPropagation();
    });

    /* Quick view button */
    sectionEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.bs-size-btn');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.dataset.handle) openQV(btn.dataset.handle);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.bs-card-overlay') && !e.target.closest('.bs-atc-btn')) closeAllOverlays(null);
    });

    /* ── Quick View Modal ─────────────────────────────────── */
    var qvOverlay = document.getElementById('bsQv-' + SID);
    var qvClose = document.getElementById('bsQvClose-' + SID);
    var qvMainImg = document.getElementById('bsQvImg-' + SID);
    var qvThumbs = document.getElementById('bsQvThumbs-' + SID);
    var qvDetails = document.getElementById('bsQvDetails-' + SID);
    var curProduct = null, curVariant = null, curQty = 1;

    function setMainImage(src) {
      if (!src) return;
      var url = normalizeImageUrl(src, 800);
      qvMainImg.style.opacity = '0.3';
      qvMainImg.src = url;
      qvMainImg.onload = qvMainImg.onerror = function () { qvMainImg.style.opacity = '1'; };
    }

    function buildThumbnails(product) {
      qvThumbs.innerHTML = '';
      qvMainImg.src = '';
      if (!product.images || !product.images.length) {
        if (product.featured_image) { qvMainImg.src = normalizeImageUrl(product.featured_image, 800); qvMainImg.alt = product.title; }
        return;
      }
      product.images.forEach(function (img, idx) {
        var src = img.src || img;
        var th = document.createElement('img');
        th.className = 'qv-thumb' + (idx === 0 ? ' is-on' : '');
        th.src = normalizeImageUrl(src, 160);
        th.alt = product.title;
        th.addEventListener('click', function () {
          document.querySelectorAll('#bsQvThumbs-' + SID + ' .qv-thumb').forEach(function (t) { t.classList.remove('is-on'); });
          th.classList.add('is-on');
          setMainImage(src);
        });
        qvThumbs.appendChild(th);
      });
      setMainImage(product.images[0].src || product.images[0]);
    }

    function updatePriceAndButton() {
      if (!curVariant) return;
      var pe = document.getElementById('qvPrice-' + SID),
        ce = document.getElementById('qvCompare-' + SID),
        ab = document.getElementById('qvAtcBtn-' + SID);
      if (pe) pe.textContent = formatMoney(curVariant.price);
      if (ce) {
        if (curVariant.compare_at_price && curVariant.compare_at_price > curVariant.price) {
          ce.textContent = formatMoney(curVariant.compare_at_price); ce.style.display = '';
        } else ce.style.display = 'none';
      }
      if (ab) { ab.disabled = !curVariant.available; ab.textContent = curVariant.available ? 'ADD TO CART' : 'SOLD OUT'; }
      if (curVariant.featured_image && curVariant.featured_image.src) {
        var cur = qvMainImg.src.split('?')[0],
          vurl = normalizeImageUrl(curVariant.featured_image.src, 800).split('?')[0];
        if (cur !== vurl) setMainImage(curVariant.featured_image.src);
      }
    }

    function buildOptionSelectors(product) {
      if (!product.options || !product.options.length) return '';
      var html = '';
      for (var i = 0; i < product.options.length; i++) {
        var opt = product.options[i], optName = typeof opt === 'object' && opt !== null ? opt.name : opt;
        var vals = Array.from(new Set(product.variants.map(function (v) { return v['option' + (i + 1)]; })));
        html += '<div class="qv-options-group"><div class="qv-lbl">' + optName + '</div><div class="qv-option-values" data-option-index="' + i + '">';
        vals.forEach(function (val) {
          var ok = product.variants.some(function (v) { return v['option' + (i + 1)] === val && v.available; });
          html += '<button class="qv-option-btn' + (ok ? '' : ' is-na') + '" data-option-value="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        html += '</div></div>';
      }
      return html;
    }

    function attachOptionListeners(product) {
      var groups = qvDetails.querySelectorAll('.qv-options-group');
      groups.forEach(function (group, gi) {
        group.querySelectorAll('.qv-option-btn:not(.is-na)').forEach(function (btn) {
          if (btn._l) btn.removeEventListener('click', btn._l);
          btn._l = function () {
            group.querySelectorAll('.qv-option-btn').forEach(function (b) { b.classList.remove('is-on'); });
            btn.classList.add('is-on');
            var sel = [];
            groups.forEach(function (g, i) { var a = g.querySelector('.qv-option-btn.is-on'); sel[i] = a ? a.dataset.optionValue : null; });
            var m = product.variants.find(function (v) {
              for (var i = 0; i < product.options.length; i++) { if (v['option' + (i + 1)] !== sel[i]) return false; }
              return true;
            });
            if (m) { curVariant = m; updatePriceAndButton(); }
          };
          btn.addEventListener('click', btn._l);
        });
        if (!group.querySelector('.qv-option-btn.is-on')) {
          var def = product.variants.find(function (v) { return v.available; }) || product.variants[0];
          if (def) {
            for (var i = 0; i < product.options.length; i++) {
              var dv = def['option' + (i + 1)], tg = groups[i];
              if (tg) {
                var tb = Array.prototype.slice.call(tg.querySelectorAll('.qv-option-btn')).find(function (b) { return b.dataset.optionValue === dv; });
                if (tb) tb.classList.add('is-on');
              }
            }
          }
        }
      });
    }

    function buildDetails(product) {
      if (!product || !product.variants) return;
      curProduct = product;
      curVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      curQty = 1;
      buildThumbnails(product);
      var optHtml = buildOptionSelectors(product);
      var descHtml = product.description
        ? '<button class="qv-desc-toggle" id="qvDescToggle-' + SID + '">Description <span class="qv-desc-icon">+</span></button><div class="qv-desc-body" id="qvDescBody-' + SID + '">' + product.description + '</div>'
        : '';
      qvDetails.innerHTML =
        '<h3 class="qv-title">' + product.title + '</h3>'
        + '<div class="qv-price-row"><span class="qv-price" id="qvPrice-' + SID + '">' + formatMoney(curVariant.price) + '</span>'
        + '<span class="qv-compare" id="qvCompare-' + SID + '" style="' + (curVariant.compare_at_price && curVariant.compare_at_price > curVariant.price ? '' : 'display:none') + '">' + (curVariant.compare_at_price ? formatMoney(curVariant.compare_at_price) : '') + '</span></div>'
        + optHtml
        + '<div class="qv-qty-row"><div class="qv-qty-selector">'
        + '<button class="qv-qty-btn" id="qvQtyMinus-' + SID + '">&#8722;</button>'
        + '<input class="qv-qty-input" id="qvQtyInput-' + SID + '" type="number" value="1" min="1" max="' + (curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999) + '" step="1">'
        + '<button class="qv-qty-btn" id="qvQtyPlus-' + SID + '">+</button>'
        + '</div><button class="qv-atc" id="qvAtcBtn-' + SID + '"' + (curVariant.available ? '' : ' disabled') + '>' + (curVariant.available ? 'ADD TO CART' : 'SOLD OUT') + '</button></div>'
        + descHtml;

      var qi = document.getElementById('qvQtyInput-' + SID),
        qm = document.getElementById('qvQtyMinus-' + SID),
        qp = document.getElementById('qvQtyPlus-' + SID);

      if (qi) {
        qi.addEventListener('change', function () {
          var v = parseInt(this.value);
          if (isNaN(v) || v < 1) v = 1;
          var max = curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999;
          if (v > max) v = max;
          curQty = v; this.value = v;
        });
        if (qm) qm.addEventListener('click', function () { var v = Math.max(1, curQty - 1); curQty = v; qi.value = v; });
        if (qp) qp.addEventListener('click', function () {
          var max = curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999;
          var v = Math.min(max, curQty + 1); curQty = v; qi.value = v;
        });
      }

      var dt = document.getElementById('qvDescToggle-' + SID), db = document.getElementById('qvDescBody-' + SID);
      if (dt && db) dt.addEventListener('click', function () { var o = db.classList.toggle('is-open'); dt.classList.toggle('is-open', o); });

      var ab = document.getElementById('qvAtcBtn-' + SID);
      if (ab) ab.addEventListener('click', function () {
        if (!curVariant || !curVariant.available) return;
        ab.disabled = true; ab.textContent = 'Adding…';
        fetchAddToCart(curVariant.id, curQty,
          function () {
            ab.textContent = '✓ Added!';
            openCartDrawer();
            setTimeout(function () { ab.disabled = false; ab.textContent = 'ADD TO CART'; }, 2200);
          },
          function () { ab.disabled = false; ab.textContent = 'ADD TO CART'; alert('Could not add to cart.'); }
        );
      });

      attachOptionListeners(product);
      updatePriceAndButton();
    }

    function openQV(handle) {
      qvDetails.innerHTML = '<div class="qv-spinner">Loading product…</div>';
      qvMainImg.src = '';
      qvThumbs.innerHTML = '';
      qvOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (productCache[handle]) { buildDetails(productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { productCache[handle] = p; buildDetails(p); })
        .catch(function () { qvDetails.innerHTML = '<div class="qv-spinner">Failed to load. Please try again.</div>'; });
    }

    function closeQV() {
      qvOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      curProduct = null; curVariant = null;
    }

    if (qvClose) qvClose.addEventListener('click', closeQV);
    if (qvOverlay) qvOverlay.addEventListener('click', function (e) { if (e.target === qvOverlay) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qvOverlay && qvOverlay.classList.contains('is-open')) closeQV(); });

    /* ── Typing effect ────────────────────────────────────── */
    var typeEl = document.getElementById('bsType-' + SID);
    if (typeEl) {
      var rawPhrases = sectionEl.dataset.typingPhrases || '';
      var phrases = rawPhrases.split(',').map(function (p) { return p.trim(); }).filter(Boolean);
      var TS = parseInt(sectionEl.dataset.typingSpeed, 10) || 80;
      var DS = Math.max(30, Math.floor(TS / 2));
      if (phrases.length) {
        var pi = 0, ci = 0, del = false;
        (function tick() {
          var ph = phrases[pi];
          if (!del) {
            typeEl.textContent = ph.slice(0, ++ci);
            if (ci >= ph.length) { del = true; setTimeout(tick, 1800); }
            else setTimeout(tick, TS);
          } else {
            typeEl.textContent = ph.slice(0, --ci);
            if (ci <= 0) { del = false; pi = (pi + 1) % phrases.length; }
            setTimeout(tick, DS);
          }
        })();
      }
    }
  }

  /* ── Boot: init all sections on page ─────────────────── */
  document.querySelectorAll('[data-sid]').forEach(function (el) {
    if (el.classList.contains('bsell-root')) initSection(el);
  });

})();